import { SxProps, Theme } from '@mui/material';

interface Styles {
  messageContainer: (isUserMessage: boolean) => SxProps<Theme>;
  messageBubble: (isUserMessage: boolean) => SxProps<Theme>;
  messageAvatar: SxProps<Theme>;
  messageText: SxProps<Theme>;
  messageTime: (isUserMessage: boolean) => SxProps<Theme>;
}

export const styles: Styles = {
  messageContainer: (isUserMessage) => ({
    alignSelf: isUserMessage ? 'flex-end' : 'flex-start',
    maxWidth: { xs: '90%', sm: '94%' },
    width: '100%',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: isUserMessage ? 'row-reverse' : 'row',
    gap: 1,
    ml: isUserMessage ? 'auto' : 0,
    mr: isUserMessage ? 0 : 'auto',
    px: 1,
  }),

  messageBubble: (isUserMessage) => ({
    bgcolor: isUserMessage
      ? 'var(--lia-popup-background-user-message)'
      : 'var(--lia-popup-background-message)',
    color: 'var(--title-font-color-grey-10)',
    borderRadius: '12px',
    borderBottomLeftRadius: isUserMessage ? '12px' : 0,
    borderBottomRightRadius: isUserMessage ? 0 : '12px',
    px: { xs: 1.5, sm: 2 },
    py: { xs: 1, sm: 1.5 },
    position: 'relative',
    fontSize: { xs: 14, sm: 16 },
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    maxWidth: '100%',

    "& *": {
      fontFamily: "var(--font-family-primary), sans-serif",
    },
  }),

  messageAvatar: {
    width: 38,
    height: 38,
    background: 'var(--lia-popup-background-avatar-gradient)',
    padding: '1px',
    '& img': {
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      backgroundColor: 'white',
    },
  },

  messageText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.5px',
    color: 'var(--title-font-color-black-10)',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    px: { xs: '0.7rem', sm: '0.4rem' },
  },

  messageTime: (isUserMessage) => ({
    mt: 0.5,
    textAlign: 'right',
    display: 'block',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: isUserMessage ? '#E2E8F0' : '#475569',
    fontFamily: 'Montserrat',
  }),
};
